import { Box, Button, Stack, Typography } from "@mui/material";
import { soHeaderEditableColumnList, syncSoDocumentDate } from "../data";
import SoColumnField from "../SoColumnField";
import SoLineItemsSection from "../SoLineItemsSection/SoLineItemsSection";
import DisplaySoHeaderDetails from "../DisplaySoHeaderDetails/DisplaySoHeaderDetails";
import { SoPanel, soColors, soPrimaryBtnSx, soSecondaryBtnSx } from "../soUi";

const SalesOrderForm = ({
	value,
	onChange,
	readOnly = false,
	onSave,
	onPublish,
	saving = false,
	variant = "create",
}) => {
	const form = value || {};
	const isSelectedView = variant === "selected";

	const setForm = (updater) => {
		const next = typeof updater === "function" ? updater(form) : updater;
		onChange(syncSoDocumentDate(next));
	};

	const handleHeaderSave = (headerDraft) => {
		onChange(
			syncSoDocumentDate({
				...form,
				...headerDraft,
				items: form.items || [],
			})
		);
	};

	const handleItemsChange = (items) => {
		onChange({ ...form, items });
	};

	return (
		<Stack spacing={2}>
			{isSelectedView ? (
				<SoPanel contentSx={{ pt: 1.5, pb: 1.5 }}>
					<DisplaySoHeaderDetails data={form} onSave={handleHeaderSave} disableEdit={readOnly} />
				</SoPanel>
			) : (
				<SoPanel title="Header" subtitle="Owner site, destination site, order no and dates">
					<Box display="flex" flexWrap="wrap" columnGap="2%" width="100%">
						{soHeaderEditableColumnList.map((column) => (
							<SoColumnField
								key={column.key}
								column={column}
								data={form}
								setData={setForm}
								readOnly={readOnly || column.disabled}
								width="22%"
							/>
						))}
					</Box>
				</SoPanel>
			)}

			<SoLineItemsSection items={form.items || []} onChange={handleItemsChange} readOnly={readOnly} />

			{!readOnly && (
				<Box
					sx={{
						display: "flex",
						flexWrap: "wrap",
						gap: 1,
						justifyContent: "flex-end",
						px: 2,
						py: 1.5,
						bgcolor: soColors.white,
						border: `1px solid ${soColors.line}`,
						borderRadius: "14px",
						position: "sticky",
						bottom: 8,
						zIndex: 2,
						boxShadow: "0 -4px 20px rgba(0,0,0,0.04)",
					}}>
					<Button variant="contained" onClick={onSave} disabled={saving} sx={soPrimaryBtnSx}>
						{saving ? "Saving…" : "Save draft"}
					</Button>
					{onPublish && (
						<Button variant="outlined" onClick={onPublish} disabled={saving} sx={soSecondaryBtnSx}>
							Publish
						</Button>
					)}
				</Box>
			)}

			{readOnly && (
				<Box
					sx={{
						px: 2,
						py: 1.25,
						borderRadius: "12px",
						border: `1px solid ${soColors.warnBg}`,
						bgcolor: soColors.warnBg,
					}}>
					<Typography sx={{ fontSize: 13, fontWeight: 600, color: soColors.warn }}>
						This SO is published and locked for editing.
					</Typography>
				</Box>
			)}
		</Stack>
	);
};

export default SalesOrderForm;
